export default {
    height: {
        full: '100%',
        bar: '50px',
    },
    width: {
        full: '100%',
    },
};